import React, { useState } from "react";
import { RiArrowDownSLine, RiArrowUpSLine } from "react-icons/ri";

const ProductDescription = ({ description }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  // Parse description as HTML
  const createMarkup = (html) => {
    return { __html: html };
  };

  return (
    <div className="">
      <h3 className="text-lg font-semibold">Description</h3>
      <div className="mt-2">
        <div className={`${!isExpanded ? "max-h-32 overflow-hidden" : ""}`}>
          {description ? (
            description.split("\n").map((line, index) => (
              <p key={index} dangerouslySetInnerHTML={createMarkup(line)} />
            ))
          ) : (
            "No description available"
          )}
        </div>
        
        {!isExpanded && (
          <div className="gradient-fade h-12 bg-gradient-to-t from-white to-transparent relative -mt-12"></div>
        )}
      </div>
      <button 
        onClick={toggleExpand}
        className="flex items-center text-blue-600 mt-2 hover:underline"
      >
        {isExpanded ? (
          <>
            Show less <RiArrowUpSLine className="ml-1" />
          </>
        ) : (
          <>
            Show more <RiArrowDownSLine className="ml-1" />
          </>
        )}
      </button>
    </div>
  );
};

export default ProductDescription;